module.exports = __webpack_public_path__ + "static/media/dota2-selector-color.ce734e4f.png";